import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function loadTrackingDetailNotifyExt(params) {
  return request({
    url: URL.sys.loadTrackingDetailNotifyExt,
    method: 'get',
    params
  })
}

export function batchSave(data) {
  return request({
    url: URL.sys.trackingDetailNotifyExtBatchSave,
    method: 'post',
    data
  })
}

export function remove(params) {
  return request({
    url: URL.sys.trackingDetailNotifyExt,
    method: 'delete',
    params
  })
}
